module.exports = __webpack_public_path__ + "static/media/3.2c1f2c22.png";